import { CheerioSlimApi } from '../cheerio/cheerio';

/**
 * Removes all not approved data attributes from html. This function is used to sanitize
 * arbitrary html pasted into tinymce.
 */
export const removeDataAttributes = (approvedDataAttributes: string[]) => ($: CheerioSlimApi) => {
  $('*').each((_i: number, element) => {
    const tmp = element as any;
    if (tmp) {
      tmp.attribs = Object.fromEntries(
        Object.entries(tmp.attribs).filter(([key]) => !key.startsWith('data') || approvedDataAttributes.includes(key)),
      );
    }
  });

  return $;
};

function removeHtmlElementsByType($: CheerioSlimApi, type: string) {
  $('*')
    .contents()
    .filter((_i: number, element) => element.type === type)
    .remove();
  return $;
}

export function removeHtmlComments($: CheerioSlimApi) {
  return removeHtmlElementsByType($, 'comment');
}

export function removeHtmlDirectives($: CheerioSlimApi) {
  return removeHtmlElementsByType($, 'directive');
}

/**
 * Removes popup image fragments from on2 content as pictures are not allowed in son tinymce.
 */
export function removePopupImageFragments($: CheerioSlimApi) {
  $('div[class="popupBild"]').remove();

  return $;
}

/*
  Removes search list tables from on2 content migrated to son when pasted into tinymce.
  Search list tables are removed because their content would be static after paste and not updating according
  to the search defined in on2.
 */
export function removeSearchListTable($: CheerioSlimApi) {
  let toBeRemoved = $('table[data-remove-on-paste="true"]');
  if (toBeRemoved.parent().attr('class') === 'responsive-tables') {
    toBeRemoved = toBeRemoved.parent();

    if (toBeRemoved.parent().attr('data-unfunctional-partial-block') === '') {
      toBeRemoved = toBeRemoved.parent();

      if (toBeRemoved.parent().attr('data-replace-by') !== '') {
        toBeRemoved = toBeRemoved.parent();

        if (toBeRemoved.parent().attr('class') === '') {
          toBeRemoved = toBeRemoved.parent();
        }
      }
    }
  }

  toBeRemoved.remove();

  return $;
}
